import script from "./UsersIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./UsersIndex.vue?vue&type=script&lang=ts&setup=true"

import "./UsersIndex.vue?vue&type=style&index=0&id=71ffef90&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71ffef90"]])

export default __exports__